<template lang="pug">
.explorer.overflow-hide
  .content.flex.column.p-20.gap-20.overflow-overlay
    .bg-image.rwd-only.flex.column.justify-end.p-20.gap-10
      .search-title 尋找文章、課程或活動
      .input-row.flex.align-center.gap-20
        el-input(placeholder="輸入關鍵字", v-model="keyword", @keyup.enter.native="customSearch")
          i.el-icon-search(slot="prefix")
        el-button(type="primary", round, @click="customSearch") 搜尋
    .desktop-search.flex.column.justify-end.p-20.gap-10
      .search-title 尋找文章、課程或活動
      .input-row.flex.align-center.gap-20
        el-input(placeholder="輸入關鍵字", v-model="keyword", @keyup.enter.native="customSearch")
          i.el-icon-search(slot="prefix")
        el-button(type="primary", round, @click="customSearch") 搜尋
    template(v-if="showSearchResult")
      .title.flex.align-center.gap-10
        .dots.flex.align-center.gap-4
          .dot.green
          .dot.yellow
          .dot.red
        .text 搜尋結果
      .items
        search-result(v-for="(result, idx) in results", :key="result.url || idx", :data="result")
    template(v-else)
      .no-result.text-secondary(v-if="noResultKeyword !== ''") 查無「{{ noResultKeyword }}」的搜尋結果
      .title.flex.align-center.gap-10
        .dots.flex.align-center.gap-4
          .dot.green
          .dot.yellow
          .dot.red
        .text 熱門文章
      .items
        article-item(v-for="article in articles", :data="article", :key="article.url")
      .title.flex.align-center.gap-10
        .dots.flex.align-center.gap-4
          .dot.green
          .dot.yellow
          .dot.red
        .text 熱門課程
      .items
        course-item(v-for="course in courses", :data="course", :key="course.url")
</template>

<script>
import {
  getArticles,
  getCourses,
} from '@/api/app';
import { searchArticles } from '../api/explorer';
import Article from '../components/Article.vue';
import Course from '../components/Course.vue';
import SearchResult from '../components/SearchResult.vue';

export default {
  components: {
    'article-item': Article,
    'course-item': Course,
    'search-result': SearchResult,
  },
  data() {
    return {
      articles: [],
      courses: [],
      keyword: '',
      results: [],
      noResultKeyword: '',
    };
  },
  computed: {
    showSearchResult() {
      return this.results.length > 0;
    },
  },
  methods: {
    async loadData() {
      this.$execWithLoading(async () => {
        // 熱門活動（/v1/activities/popular）的結果畫面從未使用，不再發出多餘請求
        await Promise.all([
          this.loadArticles(),
          this.loadCourses(),
        ]);
      }, (e) => {
        this.$showAxiosException('載入熱門文章與課程失敗', e);
      });
    },
    async loadArticles() {
      const rsp = await getArticles();
      this.articles = rsp.slice(0, 6);
    },
    async loadCourses() {
      const rsp = await getCourses();
      this.courses = rsp.slice(0, 6);
    },
    async customSearch() {
      this.keyword = this.keyword.trim();
      this.noResultKeyword = '';
      if (this.keyword === '') {
        this.loadData();
        this.results = [];
        return;
      }
      this.$execWithLoading(async () => {
        const rsp = await searchArticles(this.keyword);
        // 後端回傳 [{ title, url, snippet }]，0 筆時為空陣列
        this.results = Array.isArray(rsp) ? rsp : [];
        if (this.results.length === 0) {
          this.noResultKeyword = this.keyword;
        }
      }, (e) => {
        // 搜尋失敗時清掉上一次的結果，避免誤以為是新關鍵字的結果
        this.results = [];
        this.$showAxiosException('搜尋失敗', e);
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
.explorer {
  position: relative;
  .content {
    position: relative;
    height: 100%;
  }
  .bg-image {
    background-image: url('/image/app-explore.svg');
    background-size: cover;
    margin: -20px;
    margin-bottom: 0;
    height: 400px;
    flex: 0 0 180px;
    position: sticky;
    top: -80px;
    z-index: 1;
  }
  .desktop-search {
    // 與 .rwd-only（800px 以下顯示）使用同一個斷點，避免 721–800px 同時出現兩份搜尋列
    @media screen and (max-width: 800px) {
      display: none;
    }
  }
  .no-result {
    padding: 0 20px;
  }
  .search-title {
    color: rgba(126, 108, 100, 0.96);
    font-family: Arial;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 150% */
    text-align: left;
  }
  .title {
    padding: 0 20px;
    .dot {
      width: 8px;
      height: 8px;
      border-radius: 4px;
      &.green {
        background: #5AB0AC;
      }
      &.yellow {
        background: #FFD68D;
      }
      &.red {
        background: #E08E9F;
      }
    }
  }
  .items {
    padding: 0 20px;
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }
}

</style>

<style lang="scss">
.explorer {
  .el-input {
    .el-input__prefix {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
    }
    input {
      border-radius: 20px;
      padding-left: 40px;
    }
  }
}
</style>
